const binding = { modules: {}, dataActions: {} };

    (binding.modules['embed-youtube'] = {
        c: () => require('partner/modules/embed-youtube/embed-youtube.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'embed-youtube',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/embed-youtube'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|embed-youtube|embed-youtube'] = {
                c: () => require('partner/modules/embed-youtube/embed-youtube.view.tsx'),
                cn: '__local__-__local__-embed-youtube'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };